import { useEffect, useRef, useState } from 'react';

/**
 * A phone's or browser's Back leaves the site unless there is a history step to use up, so one is kept while anything
 * is open. Each Back runs onBack, and a new step goes in if something is still open underneath.
 * The TV apps send Back through __zflixDispatchTvBack and never use this.
 */
export function usePhoneBack(open, onBack) {
  const stepRef = useRef(false);
  const skipPopRef = useRef(false);
  const onBackRef = useRef(onBack);
  onBackRef.current = onBack;
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (document.documentElement.classList.contains('zflix-tv-apk-density')) return;
    if (open && !stepRef.current) {
      stepRef.current = true;
      window.history.pushState({ zflixBack: true }, '');
    } else if (!open && stepRef.current) {
      /** Closed on screen: take the unused step away, or the next Back would appear to do nothing. */
      stepRef.current = false;
      skipPopRef.current = true;
      window.history.back();
    }
  }, [open, tick]);

  useEffect(() => {
    const onPop = () => {
      if (skipPopRef.current) {
        skipPopRef.current = false;
        return;
      }
      /** Still on our step means the Jellyfin player just used up its own step above it. */
      if (!stepRef.current || window.history.state?.zflixBack) return;
      stepRef.current = false;
      onBackRef.current();
      setTick((t) => t + 1);
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
}
